export const change = () => {
    return {
        width: '1350px',
        title: '变更流程示意',
        height: '540px',
        ranksep: 85,
        nodesep:30,
        nodes: [
            {
                id: 'start',
                data: { label: '提交合同变更申请' },
                type: 'rect',
                style: { size: 60, labelMaxWidth: 45, fill: '#D8D839' },
            },
            {
                id: 'checkType',
                data: { number:30,label: '判定合同分类' },
                type: 'diamond',
                style: { size: 80, labelMaxWidth: 60, fill: '#DF9931' },
            },
            {
                id: 'checkStatus1',
                data: { label: '判定合同状态' },
                type: 'diamond',
    
                style: { size: 80, labelMaxWidth: 60, fill: '#DF9931' },
            },
            {
                id: 'checkStatus3',
                data: { label: '判定合同状态' },
                type: 'diamond',
           
                style: { size: 80, labelMaxWidth: 60, fill: '#DF9931' },
            },
            {
                id: 'error1-1',
                data: {  label: '报错提示'},
                type: 'rect',
                
                style: { size: [100, 40], labelMaxWidth: 50, fill: '#eb0b0b' },
            },
            {
                id: 'noInvoice',
                data: { label: '是否满足未开发票或申请发票被驳回或所开发票都退票' },
                type: 'diamond',
                style: { size: [170, 90], labelMaxWidth: 85, fill: '#DF9931' }
            },
                {
                id: 'toFormal',
                data: { label: '合同是否已释放原始数据且合同变更为正式合同' },
                type: 'diamond',
                style: { size: [170, 90], labelMaxWidth: 85, fill: '#DF9931' }
            },
            {
                id: 'error1-2',
                data: {  label: '报错提示'},
                type: 'rect',
                
                style: { size: [100, 40], labelMaxWidth: 50, fill: '#eb0b0b'},
            },
        
            {
                id: 'error2-1',
                data: { label: '报错提示' },
                type: 'rect',
                style: { size: [100, 40], labelMaxWidth: 80, fill: '#eb0b0b' },
            },
            {
                id: 'checkMachineTestItems',
                data: { label: '变更内容中是否删除项目管理系统存在的上机测序项目' },
                type: 'diamond',
                style: { size: [170, 90], labelMaxWidth: 90, fill: '#DF9931' }
            },
            {
                id: 'error2-2',
                data: { label: '报错提示' },
                type: 'rect',
                style: { size: [100, 40], labelMaxWidth: 80, fill: '#eb0b0b' },
            },
            {
                id: 'error3-1',
                data: { number:45,label: '报错提示' },
                type: 'rect',
                style: { size: [100, 40], labelMaxWidth: 80, fill: '#eb0b0b' },
            },
            {
                id: 'audit',
                data: { number:45,label: '审批' + `\n` + '审批人:詹海燕' },
                type: 'rect',
                style: { size: [90, 50], labelMaxWidth: 70, },
            },
            {
                id: 'defeat',
                data: { label: '未通过审批' },
                type: 'rect',
                style: { size: [90, 40], labelMaxWidth: 70, fill: '#eb0b0b' },
            },
            {
                id: 'success',
                data: { label: '合同变更完成' },
                type: 'rect',
                style: { size: [90, 40], labelMaxWidth: 70, fill: '#3CC457' },
            },
        ],
        edges: [
            {
                source: 'start',
                target: 'checkType',
                style: { sourcePort: 'right', targetPort: 'left' },
                type: 'line',
            },
            {
                source: 'checkType',
                target: 'checkStatus1',
                type: 'polyline',
                style: { sourcePort: 'top', targetPort: 'left' },
                data: { label: '其他合同' },
            },
            {
                source: 'checkType',
                target: 'checkStatus3',
                type: 'polyline',
                style: { sourcePort: 'bottom', targetPort: 'left' },
                data: { label: '预付款扣款合同' },
            },
            {
                source: 'checkStatus1',
                target: 'error1-1',
                type: 'polyline',
                style: { sourcePort: 'top', targetPort: 'left' },
                data: { label: '待审核或已驳回合同' },
            },
            {
                source: 'checkStatus1',
                target: 'noInvoice',
                type: 'polyline',
                style: { sourcePort: 'bottom', targetPort: 'left' },
                data: { label: '已通过合同' + `\n` + '审批人：詹海燕' },
            },
            {
                source: 'checkStatus3',
                target: 'error1-2',
                type: 'polyline',
                style: { sourcePort: 'bottom', targetPort: 'left' },
                data: { label: '待审核或已驳回合同' },
            },
            {
                source: 'checkStatus3',
                target: 'toFormal',
                type: 'polyline',
                style: { sourcePort: 'top', targetPort: 'left' },
                data: { label: '已通过合同' + `\n` + '审批人：詹海燕' },
            },
            {
                source: 'noInvoice',
                target: 'error2-1',
                type: 'polyline',
                style: { sourcePort: 'top', targetPort: 'left' },
                data: { label: '否' },
            },
            {
                source: 'noInvoice',
                target: 'checkMachineTestItems',
                type: 'polyline',
                style: { sourcePort: 'right', targetPort: 'left' },
                data: { label: '是' },
            },
            {
                source: 'toFormal',
                target: 'error2-2',
                type: 'polyline',
                style: { sourcePort: 'bottom', targetPort: 'left' },
                data: { label: '是' },
            },
            {
                source: 'toFormal',
                target: 'checkMachineTestItems',
                type: 'polyline',
                style: { sourcePort: 'right', targetPort: 'left' },
                data: { label: '否' },
            },
            {
                source: 'checkMachineTestItems',
                target: 'error3-1',
                type: 'polyline',
                style: { sourcePort: 'top', targetPort: 'left' },
                data: { label: '是' },
            },
            {
                source: 'checkMachineTestItems',
                target: 'audit',
                type: 'polyline',
                style: { sourcePort: 'bottom', targetPort: 'left' },
                data: { label: '否' },
            },
            {
                source: 'audit',
                target: 'defeat',
                type: 'polyline',
                style: { sourcePort: 'top', targetPort: 'left' },
                data: { label: '未通过审批' },
            },
            {
                source: 'audit',
                target: 'success',
                type: 'polyline',
                style: { sourcePort: 'bottom', targetPort: 'left' },
                data: { label: '通过审批' },
            },
        ],
    };
};